var map = {
	"./certificate.router.js": "7e81",
	"./college.router.js": "65b5",
	"./course.router.js": "05b2",
	"./degree.router.js": "3528",
	"./distribute.router.js": "6f00",
	"./finance.router.js": "53ba",
	"./live.router.js": "ee36",
	"./scenter.router.js": "8ba4",
	"./teacher.router.js": "f79f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a40";